export const RESET = 'ApplicationAdd/RESET'

export default {
  SET_PRODUCT_ID: 'ApplicationAdd/SET_PRODUCT_ID',

  industrySubIDOptionsSource: {
    SET: 'ApplicationAdd/industrySubIDOptionsSource/SET',
    DELETE: 'ApplicationAdd/industrySubIDOptionsSource/DELETE',
  },
  industrySubDetailOptionsSource: {
    SET: 'ApplicationAdd/industrySubDetailOptionsSource/SET',
    DELETE: 'ApplicationAdd/industrySubDetailOptionsSource/DELETE',
  },
  loanEndDate: {
    SET: 'ApplicationAdd/loanEndDate/SET',
    DELETE: 'ApplicationAdd/loanEndDate/DELETE',
  },
  reqCurrencyValData: {
    SET: 'ApplicationAdd/reqCurrencyValData/SET',
    DELETE: 'ApplicationAdd/reqCurrencyValData/DELETE',
  },
}
